import React, { useEffect, useState } from 'react'
import { faAngleRight } from "@fortawesome/free-solid-svg-icons"
import { IoCreate, IoPersonOutline, IoSearchOutline, IoDocumentText, IoCardSharp } from 'react-icons/io5'
import { FaCcMastercard, FaDolly, FaFileDownload, FaFileUpload, FaFlag, FaLayerGroup, FaMoneyCheckAlt, FaReceipt, FaTruck } from "react-icons/fa"
import { Icone } from "../../Components/Icones/Index"
import { MenuItem } from "./menu-item"
import Logo4 from '../../assets/imagens/Logo4.png'
import { Link } from "react-router-dom"
import { BsCashCoin, BsFillBoxSeamFill, BsTagsFill } from "react-icons/bs"
import { AiOutlineSetting } from 'react-icons/ai'
import { TbReport, TbRulerMeasure, TbShoppingCartSearch } from 'react-icons/tb'
import { FaBoxesStacked, FaCartShopping, FaCubesStacked, FaGear, FaMoneyBillTransfer, FaPeopleCarryBox, FaPeopleRoof, FaUserGroup } from "react-icons/fa6"
import { MenuConfig } from './menu_config'
import { GiMoneyStack, GiPayMoney, GiReceiveMoney, GiTakeMyMoney } from 'react-icons/gi'
import { TfiMoney, TfiPrinter } from "react-icons/tfi"
import { HiDocumentDuplicate, HiDocumentText } from "react-icons/hi"
import { MdAccountBalanceWallet, MdEditDocument, MdPointOfSale } from 'react-icons/md'
import { HiClipboardDocumentList, HiOutlineClipboardDocumentList } from "react-icons/hi2"
import { TbReportAnalytics } from "react-icons/tb"
import extratoClaro from '../../assets/imagens/ExtratoClaro.svg'
import { ImUserTie } from 'react-icons/im'
import iconGrupoDespesa from '../../assets/imagens/fotoGrupoDespesa.png'
import iconSubGrupoDespesa from '../../assets/imagens/fotoSubGrupoDespesa.png'
import iconControleDeContas from '../../assets/imagens/fotoControleDeContas.png'
import iconControleDeCheque from '../../assets/imagens/fotoControleDeCheque.png'
import iconCheque from '../../assets/imagens/fotoCheque.png'


const Menu = () => {

    const [filtroPesquisa, setFiltroPesquisa] = useState("")

    const [corTemaMenu, setCorTemaMenu] = useState(localStorage.getItem('@ecommerce/cor_tema') || 'bg-blue-600')
    const [corHoverMenu, setCorHoverMenu] = useState(localStorage.getItem('@ecommerce/cor_bg_menu') || 'hover:bg-blue-700')
    const [corHoverSubMenu, setCorHoverSubMenu] = useState(localStorage.getItem('@ecommerce/cor_bg_nav') || 'hover:bg-blue-800')
    const [corBarra, setCorBarra] = useState(localStorage.getItem('@ecommerce/cor_barra') || 'scrollbar-thumb-blue-800')

    const [urlLogo, setUrlLogo] = useState(localStorage.getItem('imageLogo') || Logo4)

    /* atributos feedback */
    //const [visible, setVisible] = useState(false)
    //const [message, setMessage] = useState("")
    //const [messageType, setMessageType] = useState<AlertType>("SUCCESS")


    const handleMouseUp = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        // Desfocar o link após o clique

        const target = e.target as HTMLElement
        if (target instanceof HTMLAnchorElement) {
            target.blur()
        }
    }

    const handleKeyPressEnter = (e: any) => {

        if (e.key === "Enter" || e.key === "NumpadEnter") {
            // Prevenir a ação padrão do Enter
            e.preventDefault()
        }
    }

    useEffect(() => {
        document.addEventListener('keydown', handleKeyPressEnter)

        return () => {
            document.removeEventListener('keydown', handleKeyPressEnter)
        }
    }, [])

    // ------------------------------------------------------------ CONFIGURAÇÕES -----------------------------------------------------------------------------------------
    const styleConfig = (tema: string, hoverMenu: string, hoverSubMenu: string, corBarra: string) => {

        setCorTemaMenu(tema)
        setCorHoverMenu(hoverMenu)
        setCorHoverSubMenu(hoverSubMenu)
        setCorBarra(corBarra)

    }

    const styleLogo = (urlLogo: string) => {

        if (urlLogo === '') {
            setUrlLogo(Logo4)
        } else {
            setUrlLogo(urlLogo)
        }
    }

    const toggleConfig = () => {

        let divMenuConfig = document.getElementById('menu_config') as HTMLDivElement

        if (divMenuConfig) {
            if (divMenuConfig.classList.contains('-right-96')) {
                divMenuConfig.classList.remove('-right-96')
                divMenuConfig.classList.add('right-6')
            }
        }
    }

    // ---------------------------------------------------------- PESQUISA ------------------------------------------------------------------------------------------------
    const handlePesquisaChange = (e: any) => {
        setFiltroPesquisa(e.target.value)
    }

    /*{ descricao: "Saídas", link: "/saidaNota", iconLeft: <FaFileUpload size={"20px"} /> }, */
    /*{ descricao: "Usuários", link: "/user", iconLeft: <IoPersonOutline size={"20px"} /> }, */

    return (

        <div id="menu-lateral" className={`w-[230px] h-full lg:h-[91%] lg:rounded-md flex flex-col ml-[-230px] lg:ml-4 ${corTemaMenu} 
                                           lg:mt-[65px] border dark:border-slate-800 shadow-md shadow-slate-400 dark:shadow-slate-800 
                                           overflow-y-auto transition-all duration-500 fixed z-40`}>

            <MenuConfig
                styleConfig={(tema: string, hoverMenu: string, hoverSubMenu: string, corBarra: string) => styleConfig(tema, hoverMenu, hoverSubMenu, corBarra)}
                styleLogo={(urlLogo: string) => styleLogo(urlLogo)}
            />

            <div className={`w-full flex flex-col justify-center items-center text-white pt-2 pb-3`}>

                <div className={`w-full h-auto flex items-center justify-center rounded-[50px] text-white mt-0`}>
                    <Link tabIndex={-1} to="/">
                        <img width={178} height={157} loading='eager'  {...({ fetchpriority: 'high' } as any)} className={`w-[178px] h-[157px] mt-0`} src={urlLogo ? `${urlLogo}` : ''} alt="Logo da empresa" />
                    </Link>
                </div>

            </div>

            <div className={`border ml-2 mr-2`} />

            <div className={`w-full p-2 flex items-center`}>
                <IoSearchOutline className={`text-white absolute h-4 w-4 mx-2 `} />

                {/* recurso utilizado para o navegador não jogar o email do usuário nesse campo */}
                <input
                    type="text"
                    name="fake_autofill_field"
                    style={{ display: 'none' }}
                    autoComplete="username"
                />

                <input tabIndex={-1}
                    className={`text-white placeholder:text-white bg-gray-200 border-white
                    appearance-none focus:outline-none focus:ring-0 focus:border-opacity-90 peer px-2.5 pb-2.5 pt-2 cursor-pointer text-sm border bg-opacity-30 border-opacity-30 placeholder:text-opacity-50
                    focus:cursor-text w-full pl-7 h-[35px] rounded-md shadow-sm`}
                    placeholder="Pesquisar"
                    value={filtroPesquisa}
                    onChange={handlePesquisaChange}
                />
            </div>

            <div className={`h-full ${corBarra} scrollbar-track-transparent pt-2 pl-1 pr-1 scrollbar-thin dark:scrollbar-thin`}>

                <MenuItem descricao="Cadastros" iconLeft={<HiClipboardDocumentList size={"20px"} />} id='1' corHoverMenu={corHoverMenu} corHoverSubMenu={corHoverSubMenu} filtroPesquisa={filtroPesquisa} link=""
                    SubMenuLV1={[
                        { descricao: "Clientes", link: "/cliente", iconLeft: <FaUserGroup size={"20px"} /> },
                        { descricao: "Produtos", link: "/produtos", iconLeft: <BsFillBoxSeamFill size={"20px"} /> },
                        { descricao: "Marcas", link: "/marca", iconLeft: <BsTagsFill size={"20px"} /> },
                        { descricao: "Empresas", link: "/companies", iconLeft: <FaPeopleRoof size={"20px"} /> },
                        { descricao: "Grupos", link: "/grupo", iconLeft: <FaBoxesStacked size={"20px"} /> },
                        { descricao: "SubGrupos", link: "/subGrupo", iconLeft: <FaLayerGroup size={"20px"} /> },
                        { descricao: "Naturezas das Operações", link: "/naturezaOperacao", iconLeft: <IoDocumentText size={"20px"} /> },
                        { descricao: "Unidades de Medida", link: "/unidMedida", iconLeft: <TbRulerMeasure size={"20px"} /> },
                        { descricao: "Formas de Pagamento", link: "/formaPagto", iconLeft: <GiTakeMyMoney size={"20px"} /> },
                        { descricao: "Tributações", link: "/tributacao", iconLeft: <BsCashCoin size={"20px"} /> },
                        { descricao: "Fornecedores", link: "/fornecedor", iconLeft: <FaDolly size={"20px"} /> },
                        { descricao: "Grupos de Despesa", link: "/grupoDespesa", iconLeft: <img src={iconGrupoDespesa} alt="" style={{ width: '30px', height: '25px', filter: 'invert(100%)' }} /> },
                        { descricao: "SubGrupos de Despesa", link: "/sgrupoDespesa", iconLeft: <img src={iconSubGrupoDespesa} alt="" style={{ width: '30px', height: '25px', filter: 'invert(100%)' }} /> },
                        { descricao: "Transportadoras", link: "/transportadora", iconLeft: <FaTruck size={"20px"} /> },
                        { descricao: "Séries dos Doc. Fiscais", link: "/serieDoc", iconLeft: <HiDocumentText size={"20px"} /> },
                        { descricao: "Parceiros", link: "/parceiros", iconLeft: <ImUserTie size={"20px"} /> },
                        { descricao: "Contas", link: "/contas", iconLeft: <MdAccountBalanceWallet size={"20px"} /> },
                        { descricao: "Bandeiras", link: "/bandeira", iconLeft: <FaFlag size={"20px"} />, }
                    ]}
                />

                <MenuItem descricao="Estoque" iconLeft={<FaCubesStacked size={"20px"} />} id='2' corHoverMenu={corHoverMenu} corHoverSubMenu={corHoverSubMenu} filtroPesquisa={filtroPesquisa} link=""
                    SubMenuLV1={[
                        { descricao: "Acertos", link: "/estoque_acerto", iconLeft: <MdEditDocument size={"20px"} /> },
                        { descricao: "Movimentações", link: "/estoque_movimentacao", iconLeft: <FaPeopleCarryBox size={"20px"} /> },
                        { descricao: "Rel. de Produtos em Estoque", link: "/rel_estoque_produto", iconLeft: <HiOutlineClipboardDocumentList size={"20px"} /> },
                    ]}
                />

                <MenuItem descricao="Notas Fiscais" iconLeft={<FaReceipt size={"20px"} />} id='4' corHoverMenu={corHoverMenu} corHoverSubMenu={corHoverSubMenu} filtroPesquisa={filtroPesquisa} link=""
                    SubMenuLV1={[
                        { descricao: "Entradas", link: "/entradaNota", iconLeft: <FaFileDownload size={"20px"} /> },
                        { descricao: "Configuração", link: "/configNF", iconLeft: <FaGear size={"20px"} /> },
                    ]}
                />

                <MenuItem descricao="Financeiro" iconLeft={<TfiMoney size={"20px"} />} id='5' corHoverMenu={corHoverMenu} corHoverSubMenu={corHoverSubMenu} filtroPesquisa={filtroPesquisa} link=""
                    SubMenuLV1={[
                        {
                            descricao: "Contas a Pagar", link: "", iconLeft: <GiPayMoney size={"20px"} />,
                            SubMenuLV2: [
                                { descricao: "Duplicatas", link: "/contaApagar", iconLeft: <HiDocumentDuplicate size={"20px"} /> },
                                { descricao: "Relatórios Dup. Pagar", link: '', iconLeft: <HiOutlineClipboardDocumentList size={"20px"} />, SubMenuLV3: [{ descricao: "Relatórios", link: "/contaApagar/relatorios", iconLeft: <TbReport color='white' size={"20px"} /> }] }
                            ]
                        },
                        {
                            descricao: "Contas a Receber", link: "", iconLeft: <GiReceiveMoney size={"20px"} />,
                            SubMenuLV2: [
                                { descricao: "Duplicatas", link: "/contaAreceber", iconLeft: <HiDocumentDuplicate size={"20px"} /> },
                                { descricao: "Relatórios Dup. Receber", link: '', iconLeft: <HiOutlineClipboardDocumentList size={"20px"} />, SubMenuLV3: [{ descricao: "Relatórios", link: "/contaAreceber/relatorios", iconLeft: <TbReport color='white' size={"20px"} /> }] }
                            ]
                        },
                        {
                            descricao: "Cartão", link: "", iconLeft: <IoCardSharp size={"20px"} />,
                            SubMenuLV2: [
                                { descricao: "Lançamento de Cartão", link: "/lanctoCartao", iconLeft: <IoCreate size={"20px"} /> },
                                
                            ]
                        },
                        {
                            descricao: "Controle de Contas", link: "", iconLeft: <img src={iconControleDeContas} alt="" style={{ width: '30px', height: '25px', filter: 'invert(100%)' }} />,
                            SubMenuLV2: [
                                { descricao: "Lançamentos", link: "/c_contas_new", iconLeft: <IoCreate size={"20px"} /> },
                                { descricao: "Transferências", link: "/c_contas_transferencia", iconLeft: <FaMoneyBillTransfer size={"20px"} /> },
                                { descricao: "Relatórios", link: "", iconLeft: <HiOutlineClipboardDocumentList size={"20px"} />, SubMenuLV3: [{ descricao: "Extrato", link: "/c_contas_extrato", iconLeft: <img src={extratoClaro} alt="Estorno" className={`h-5 w-5 flex items-center justify-center`} /> },] },
                            ]
                        },
                        {
                            descricao: "Controle de Cheques", link: "", iconLeft: <img src={iconControleDeCheque} alt="" style={{ width: '30px', height: '25px', filter: 'invert(100%)' }} />,
                            SubMenuLV2: [
                                { descricao: "Cheques", link: "/c_cheque", iconLeft: <FaMoneyCheckAlt size={"20px"} />   },
                            ] /*{ <img src={iconCheque} alt="" style={{ width: '30px', height: '25px', filter: 'invert(100%)' }} />} */
                        },
                        {
                            descricao: "Caixa", link: "", iconLeft: <MdPointOfSale size={"20px"} />,
                            SubMenuLV2: [
                                { descricao: "Suprimento/Sangria", link: "/sup_sangria", iconLeft: <GiMoneyStack size={"20px"} /> },
                                { descricao: "Rel. caixa diário", link: "/rel_caixa_diario", iconLeft: <TfiPrinter size={"20px"} /> },
                            ]
                        },
                    ]}
                />

                <MenuItem descricao="Vendas" iconLeft={<FaCartShopping size={"20px"} />} id='6'
                    iconRigth={<Icone icon={faAngleRight} size="sm" />} filtroPesquisa={filtroPesquisa} corHoverMenu={corHoverMenu} corHoverSubMenu={corHoverSubMenu} link=""
                    SubMenuLV1={[
                        { descricao: "Lançamento de Vendas", link: "/venda", iconLeft: <IoCreate size={"20px"} />, },
                        { descricao: "Consultar Vendas", link: "/venda/consulta", iconLeft: <TbShoppingCartSearch size={"20px"} />, },
                        { descricao: "Relatório de Vendas", link: "/relatorios_venda", iconLeft: <TbReportAnalytics size={"20px"} />, },
                        { descricao: "Relatório de Itens", link: "/relatorios_itens", iconLeft: <TbReportAnalytics size={"20px"} />, },
                        { descricao: "Resumo de Vendas", link: "/relatorios_resumo_vendas", iconLeft: <TbReportAnalytics size={"20px"} />, },
                    ]}
                />
            </div>

            <div id='config' className={`flex justify-start m-6`} >
                <button tabIndex={-1} onClick={toggleConfig} className={`text-white mr-16 flex flex-row items-center`}>
                    <AiOutlineSetting className={`h-6 w-6 text-white`} />
                    <span className='ml-2'>Configurações</span>
                </button>
            </div>

        </div>

    )

}

export default React.memo(Menu)